import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow } from '../components/PdfTable';

const COLS = [
  { label: '#',       flex: 0.35, align: 'center' },
  { label: 'Name',    flex: 1.5 },
  { label: 'Email',   flex: 2 },
  { label: 'Phone',   flex: 1.1 },
  { label: 'Role',    flex: 0.8, align: 'center' },
  { label: 'Joined',  flex: 1 },
  { label: 'Address', flex: 2.5 },
];

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 28, marginTop: 10 },
  footRow: { flexDirection: 'row', minHeight: 18, paddingHorizontal: 4, paddingVertical: 4 },
  footText:{ fontSize: 8.5, fontWeight: 'bold', fontFamily: 'NotoSans' },
});

function buildAddress(m) {
  return [
    m.flatNo && m.buildingName
      ? `${m.flatNo}, ${m.buildingName}`
      : (m.flatNo || m.buildingName),
    m.addressLine1,
    m.city,
  ].filter(Boolean).join(', ') || '—';
}

export default function DerasarMemberListDocument({ data, theme: themeKey, orientation, sections }) {
  const t       = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const members = Array.isArray(data?.members) ? data.members : [];

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && (
          <PdfHeader derasar={data.derasar} reportTitle="Derasar Members List" theme={t} />
        )}
        <View style={s.content}>
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Total Members', value: String(members.length), color: t.primary },
            ]} />
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {members.map((m, i) => (
            <PdfTableRow
              key={m.id || i}
              cols={COLS}
              index={i}
              theme={t}
              values={[
                String(i + 1),
                m.name         || '—',
                m.email        || '—',
                m.phone        || '—',
                m.role         || '—',
                m.joinedAtFormatted || m.joinedAt || '—',
                buildAddress(m),
              ]}
            />
          ))}
          <View style={[s.footRow, { backgroundColor: t.mid }]} wrap={false}>
            <Text style={[s.footText, { color: t.body }]}>
              {`Total: ${members.length} member${members.length !== 1 ? 's' : ''}`}
            </Text>
          </View>
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}
